// Profile picture with graceful initial fallback (used across friends/crew/profile).
export function Avatar({ src, name, size = 40, className = "", style = {} }) {
  const dim = { width: size, height: size, ...style };
  if (src) {
    return (
      <img
        src={src}
        alt={name || "profile"}
        style={dim}
        className={`rounded-full object-cover bg-secondary ${className}`}
      />
    );
  }
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";
  return (
    <div
      style={{ ...dim, fontSize: Math.round(size * 0.4) }}
      className={`rounded-full bg-brand text-white flex items-center justify-center font-bold shrink-0 ${className}`}
    >
      {initial}
    </div>
  );
}
